import React, { useEffect, useState } from "react";
import { Switch, FormControlLabel, CircularProgress } from "@mui/material";
import toggleAutoApproval from "../controllers/repayment/toggleAutoApproval";
import { enqueueSnackbar } from "notistack";
import autoApprovalStatus from "../controllers/repayment/autoApprovalStatus";

function AutoApprovalToggle() {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  const loadStatus = async () => {
    setLoading(true);
    await autoApprovalStatus({ status: !enabled })
      .then((res) => {
        if (res?.return) {
          if (res?.data?.setting) setEnabled(res?.data?.setting?.autoApprove);
        }
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    loadStatus();
  }, []);

  const handleAutoApprovalToggle = async () => {
    try {
      setLoading(true);
      await toggleAutoApproval({ status: !enabled }).then((res) => {
        if (res?.return) {
          enqueueSnackbar(
            `Auto approval ${
              res?.data?.setting?.autoApprove ? "Enabled" : "Disabled"
            }`,
            { variant: "success" }
          );
          setEnabled(res?.data?.setting?.autoApprove);
        }
      });
    } catch (err) {
      console.error("❌ Error toggling auto approval:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormControlLabel
      control={
        loading ? (
          <CircularProgress size={24} />
        ) : (
          <Switch
            checked={enabled}
            onChange={handleAutoApprovalToggle}
            color="primary"
          />
        )
      }
      label="Auto Approval"
    />
  );
}

export default AutoApprovalToggle;
